import { useEffect, useState } from "react";
import projects_list from "./static_projects";

const LoadProjectsDynamically = false

function Projects() {
    const [repos, setRepos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRepos = async () => {
            try {
                if (LoadProjectsDynamically) {
                    const response = await fetch("https://api.github.com/search/repositories?q=user:Dinesh563+topic:my-dev");
                    if (!response.ok) throw new Error('Failed to fetch repositories');

                    const data = await response.json();

                    if (data.items) {
                        const filtered = data.items.filter((repo) => !repo.fork);
                        setRepos(filtered);
                    }
                } else {
                    setRepos(projects_list)
                }

            } catch (err) {
                setError(err.message);
                console.error("Error fetching repos:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchRepos();
    }, []);

    if (loading) {
        return (
            <div id="projects" className="bg-gradient-to-r from-purple-200 to-violet-100 pt-4 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-600 mx-auto mb-4"></div>
                    <p className="text-purple-700 font-medium">Loading projects...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div id="projects" className="bg-gradient-to-r from-purple-200 to-violet-100 pt-4 flex items-center justify-center">
                <div className="bg-white p-6 rounded-xl shadow-lg max-w-md mx-4 text-center">
                    <p className="text-red-500 font-medium mb-2">Error loading projects</p>
                    <p className="text-gray-600 mb-4">{error}</p>
                    <button
                        onClick={() => window.location.reload()}
                        className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors"
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div id="projects" className="pt-4 pb-12">
            <h1 className="font-semibold text-3xl md:text-4xl mb-8 text-center text-purple-700 relative inline-block mx-auto">
                Projects
            </h1>

            {repos.length === 0 ? (
                <div className="text-center mt-2 py-2">
                    <p className="text-gray-600 text-lg">No projects found</p>
                </div>
            ) : (
                <div className="px-4 sm:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
                    {repos.map((repo, index) => (
                        <Repo key={repo.id} repo={repo} index={index} />
                    ))}
                </div>
            )}
        </div>
    );
}
function Repo({ repo, index }) {
    const topics = repo.topics?.filter((topic) => topic !== "my-dev") || [];
    const hasDemo = Boolean(repo.homepage);

    return (
        <div
            className={`bg-white p-6 rounded-xl shadow-lg border border-gray-200 hover:shadow-xl transition-all duration-300 flex flex-col justify-between group opacity-0 animate-spreadout`}
            style={{
                animationDelay: `${index * 0.1}s`
            }}
        >

            {/* Repo name with highlight effect */}
            <div className="mb-4 relative">
                <h2 className="text-2xl font-bold text-gray-900 relative inline-block">
                    <span className="relative z-10 text-shadow-lg">
                        {repo.name.replace(/-/g, ' ')}
                    </span>
                    {/* <span className="absolute bottom-0 left-0 h-2 w-full bg-indigo-100 opacity-70 group-hover:opacity-100 transition-opacity duration-300 -z-0"></span> */}
                </h2>
            </div>

            {/* Description */}
            <p className="text-gray-600 mb-5 flex-grow">
                {repo.description || "No description provided"}
            </p>

            {/* Topics */}
            {topics.length > 0 && (
                <div className="mb-5 flex flex-wrap gap-2">
                    {topics.map((topic) => (
                        <span
                            key={topic}
                            className="bg-indigo-50 text-indigo-700 text-xs font-semibold px-3 py-1 rounded-full border border-indigo-100 hover:bg-indigo-100 transition-colors"
                        >
                            {topic}
                        </span>
                    ))}
                </div>
            )}

            {/* Buttons container */}
            <div className={`mt-auto grid ${hasDemo ? 'grid-cols-2' : 'grid-cols-1'} gap-3`}>
                {/* GitHub button - always shown */}
                <a
                    href={repo.html_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-900 transition-colors text-sm font-medium"
                >
                    <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                    </svg>
                    Source Code
                </a>

                {/* Live Demo button - conditionally shown */}
                {hasDemo && (
                    <a
                        href={repo.homepage}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-4 py-2 rounded-lg hover:from-indigo-600 hover:to-purple-700 transition-all text-sm font-medium"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                        Live Demo
                    </a>
                )}
            </div>
        </div>
    );
}

export default Projects;